import styled from '@mui/material/styles/styled'
import TableCell from '@mui/material/TableCell'

export const MiddleCell = styled(TableCell, {
  name: 'MiddleCell',
  slot: 'Root',
  skipSx: true,
})`
  border: none;
  padding: 0 12px;
`
